<yw-shared-image cdkDrag
                 class="card p-2 m-2 card-image position-relative"
                 (click)="clickedImage(image)"
                 [class.active]="createService.currentImage == image"
                 *ngFor="let image of images"
                 [image]="image">
</yw-shared-image>
